module.exports = __webpack_public_path__ + "img/wh.2c685568.png";